import { useEffect, useState } from "react";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import BarChart from "../../../Components/Charts/ClientBarChart";
import Piechart from "../../../Components/Charts/ClientPieChart";
import TaskItem from "../../../Components/TaskItem/TaskItem";
import { PublicGet } from "../../../Services/Server";
import Url from "../../../Services/Url";
import "./Dashboard.css";
import User from "../../../Services/User";
import { useNavigate } from "react-router-dom";

const Dashboard = () => {
	const [taskTypeCounts, setTaskTypeCounts] = useState(null);
	const [vesselTaskData, setVesselTaskData] = useState([]);
	const [currentTaskCount, setTaskCount] = useState();
	const [tasks, setTasks] = useState({ current: [] });
	const [filterMonth, setFilterMonth] = useState(new Date().getMonth() + 1);
	const [filterYear, setFilterYear] = useState(new Date().getFullYear());
	const navigate = useNavigate();

	const company = User.getCompany();
	const companyId = company?.id;
	const tracking = company?.companyTrackingCode;

	//  Check if the company is enterprise type
	const isEnterprise = tracking?.toUpperCase().startsWith("ENT");

	useEffect(() => {
		const fetchData = () => {
			try {
				const typeCountsUrl = isEnterprise
					? Url.public.getEntTaskTypeCounts(filterYear, filterMonth, companyId)
					: Url.public.getMrtTaskTypeCounts(filterYear, filterMonth, companyId);

				const vesselOrStateUrl = isEnterprise
					? Url.public.getEntCompanyTaskByState(companyId, filterYear, filterMonth)
					: Url.public.getMrtCompanyTaskByVessel(companyId, filterYear, filterMonth);

				// --- Task Type Counts ---
				PublicGet(typeCountsUrl)
					.then((taskTypeRes) => setTaskTypeCounts(taskTypeRes))
					.catch((err) => console.error("Error fetching task type counts:", err));

				// --- Bar Chart Data (State or Vessel) ---
				PublicGet(vesselOrStateUrl)
					.then((barChartRes) => setVesselTaskData(barChartRes.content || barChartRes))
					.catch((err) => console.error("Error fetching bar chart data:", err));
			} catch (err) {
				console.error("Error fetching dashboard data:", err);
			}
		};

		fetchData();
	}, [filterMonth, filterYear, companyId, isEnterprise]);

	useEffect(() => {
		// Fetch ongoing tasks (different endpoints for enterprise vs maritime)
		const ongoingTasksUrl = isEnterprise
			? Url.public.getEntCompanyTasksDTO(tracking, 1, 0)
			: Url.public.getMrtCompanyTasksDTO(tracking, 1, 0);

		PublicGet(ongoingTasksUrl)
			.then((resp) => {
				setTasks({ current: resp.content || [] });
				setTaskCount(resp.totalElements);
			})
			.catch((err) => console.error("Error fetching ongoing tasks:", err));
	}, [tracking, isEnterprise]);

	return (
		<div className="Dashboard">
			<div className="DBLeft">
				<div className="DBLeftHead">
					<h2>Dashboard</h2>
				</div>

				<div className="DBLefttTop">
					<div className="DBPieChart">
						<Piechart
							dashboardType={isEnterprise ? "enterprise" : "maritime"}
							chartId="PieChart"
							taskCounts={taskTypeCounts}
							month={filterMonth}
							year={filterYear}
						/>
					</div>
				</div>

				<Carousel showThumbs={false} showStatus={false} emulateTouch>
					<div className="DBLeftRow">
						<BarChart
							dashboardType={isEnterprise ? "enterprise" : "maritime"}
							chartId="BarChart"
							vesselData={vesselTaskData}
							month={filterMonth}
							year={filterYear}
						/>
					</div>
				</Carousel>
			</div>

			<div className="DBRight">
				<div className="flex">
					<h3>{currentTaskCount} Ongoing Tasks</h3>
					<a
						onClick={() => navigate("/client/tasks")}
						className="text-blue-500 cursor-pointer hover:underline"
					>
						View All
					</a>
				</div>

				<div className="TaskItems">
					{tasks.current.map((task, i) => (
						<TaskItem key={i}>{task}</TaskItem>
					))}
				</div>
			</div>
		</div>
	);
};

export default Dashboard;
